
<template>
  <div class="modal">
    <div class="modal-content select-category-modal">
      <p class="btn" v-on:click="handleSubmit(null)">x</p>
      <form @submit.prevent>
        <input type="text" id="selectCategoryModelSearchInput" v-model="search" class="input" placeholder="Search Category">
      </form>
      <div class="category-list">
          <div>
              
          </div>
        <div 
          v-for="item in products" 
          :key="item._id"
          v-on:click="handleSubmit(item)"
          class="category btn"
        >
          <p>{{item.en}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['closeModal', 'onSubmit'],
  data() {
    return {
        searchTimeout: null,
        search: ''
    }
  },
  watch: {
    search: function() {
        this.searchTimeout && clearTimeout(this.searchTimeout)
        this.searchTimeout = setTimeout(
            () => this.getCategorys(), 500
        )
    },
  },
  mounted() {
      this.getCategorys();
  },
  methods: {
    handleSubmit(category) {
        this.closeModal()
        this.onSubmit(category)
    },
    getCategorys: function() {
        this.$store.dispatch("productCategoriesModule/getAllProductCategory", {
            query: {
                search: this.search,
            }
        });
    }
  },
  computed: {
    products() {
        return this.$store.state.productCategoriesModule.listALlProductCategories || [];
    }
  }
}
</script>

<style>

</style>